/**
 * @file password manage
*/
import request from '@/utils/request';

// changePwd
export const changePwd = (parameter)=> request.post('/application/resetmypassword',parameter) 
// resetPwd
export const resetPwd = (parameter)=> request.post('/application/changepassword',parameter)
